module.exports = new __parcel__URL__("correct_config_in_baggy_and_ecoflex_with_button_press.a220953e.png").toString();